export const ModalHistoryTypes = {
	GO_BACK: 'GO_BACK'
}